import React from "react"
import "./Styles.css"

export default function Image(props) {

    return (
        <img
            className={`image ${props.blackwhite ? 'blackwhite' : ''}`}
            onMouseEnter={props.hover}
            onMouseLeave={props.leave}
            src={props.link}
            alt={props.alt}
        />
    )
}